<div>
  <label *ngIf="label" [attr.for]="identifier">{{label}}</label>
  <div>
    <input style="display: inline-block;width: 63%;" [disabled]="true" type="text" class="form-control" [value]="nomeArquivo"
    />
    <input *ngIf="!downloadMode || dualMode" #inputfile style="display: inline-block;width: 0px;visibility: hidden;"
      type="file" [id]="identifier" [disabled]="disabled" (change)="onFileSelect($event)" />
    <button *ngIf="!downloadMode || dualMode" style="display: inline-block;width: 15%;margin-bottom: 2px;" type="button" class="btn btn-primary"
      (click)="clickEvent()" [disabled]="disabled">Selecionar Arquivo</button>
    <button *ngIf="downloadMode || dualMode" [disabled]="!nomeArquivo" style="display: inline-block;width: 15%;margin-bottom: 2px;" type="button" class="btn btn-primary"
      (click)="downloadEvent()">Download</button>
  </div>
  <validation [elementBase]="this"></validation>
</div>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵbg.html